import { QuickSwitchConfigItem } from '@dealstack/frontend/shared/components/QuickSwitch/QuickSwitchMenu.types';
import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';

type QuickSwitchContextType = {
	config: QuickSwitchConfigItem[] | null;
	setConfig: (config: QuickSwitchConfigItem[] | null) => void;
};

export const QuickSwitchContext = createContext<QuickSwitchContextType | null>(null);

export const QuickSwitchProvider = ({ children }: PropsWithChildren) => {
	const [config, setConfig] = useState<QuickSwitchConfigItem[] | null>(null);

	return (
		<QuickSwitchContext.Provider value={{ config, setConfig }}>
			{children}
		</QuickSwitchContext.Provider>
	);
};

export function useQuickSwitchState(): {
	config: QuickSwitchConfigItem[] | null;
} {
	const context = useContext(QuickSwitchContext);
	if (!context) {
		throw new Error('useQuickSwitchState should be used inside of QuickSwitchProvider');
	}

	return { config: context.config };
}

export const useQuickSwitch = (config?: QuickSwitchConfigItem[]) => {
	const context = useContext(QuickSwitchContext);

	if (!context) {
		throw new Error('useQuickSwitch should be used inside of QuickSwitchProvider');
	}

	useEffect(() => {
		if (config) {
			context.setConfig(config);
		}

		return () => {
			context.setConfig(null);
		};
	}, [config, context]);
};
